export default __webpack_public_path__ + "static/mobile_section4_feature2-71df2caccb1a46e8a573fa2388ca0f84.png";